'use strict';

var React = require('react');

var SvgColumns2Major = function SvgColumns2Major(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-16a2 2 0 0 1-2-2v-16Zm11 0h7v16h-7v-16Zm-2 0h-7v16h7v-16Z"
  }));
};

exports.SvgColumns2Major = SvgColumns2Major;
